export default {
  Dashboards: 'Dashboards',
  CRM: 'CRM',
  Analytics: 'Analytics',
  eCommerce: 'eCommerce',
  Calendar: 'Calendar',
  Chat: 'Chat',
  Email: 'Email',
  Invoice: 'Invoice',
  List: 'List',
  Preview: 'Preview',
  Edit: 'Edit',
  Add: 'Add',
  User: 'User',
  'User List': 'User List',
  'User View': 'User View',
  'APPS AND PAGES': 'APPS AND PAGES',
  Pages: 'Pages',
  Authentication: 'Authentication',
  'Login V1': 'Login V1',
  'Login V2': 'Login V2',
  'Register V1': 'Register V1',
  'Register V2': 'Register V2',
  'Forgot Password V1': 'Forgot Password V1',
  'Forgot Password V2': 'Forgot Password V2',
  'Reset Password V1': 'Reset Password V1',
  'Reset Password V2': 'Reset Password V2',
  Miscellaneous: 'Miscellaneous',
  'Under Maintenance': 'Under Maintenance',
  Error: 'Error',
  'Coming Soon': 'Coming Soon',
  'Not Authorized': 'Not Authorized',
  'Knowledge Base': 'Knowledge Base',
  'Account Settings': 'Account Settings',
  Pricing: 'Pricing',
  FAQ: 'FAQ',
  'USER INTERFACE': 'USER INTERFACE',
  Typography: 'Typography',
  Icons: 'Icons',
  Gamification: 'Gamification',
  Cards: 'Cards',
  Basic: 'Basic',
  Statistics: 'Statistics',
  Advance: 'Advance',
  Actions: 'Actions',
  Chart: 'Chart',
  Components: 'Components',
  Alert: 'Alert',
  Avatar: 'Avatar',
  Badge: 'Badge',
  Button: 'Button',
  Menu: 'Menu',
  'Expansion Panel': 'Expansion Panel',
  Dialog: 'Dialog',
  Pagination: 'Pagination',
  Tabs: 'Tabs',
  Tooltip: 'Tooltip',
  Chip: 'Chip',
  Snackbar: 'Snackbar',
  Stepper: 'Stepper',
  Timeline: 'Timeline',
  Treeview: 'Treeview',
  'FORMS & TABLES': 'FORMS & TABLES',
  'Forms Elements': 'Forms Elements',
  Autocomplete: 'Autocomplete',
  Checkbox: 'Checkbox',
  Combobox: 'Combobox',
  'File Input': 'File Input',
  Radio: 'Radio',
  'Range Slider': 'Range Slider',
  Select: 'Select',
  Slider: 'Slider',
  Switch: 'Switch',
  Textarea: 'Textarea',
  Textfield: 'Textfield',
  'Date Picker': 'Date Picker',
  'Month Picker': 'Month Picker',
  'Time Picker': 'Time Picker',
  Rating: 'Rating',
  'Form Layout': 'Form Layout',
  'Form validation': 'Form validation',
  Tables: 'Tables',
  'Simple Table': 'Simple Table',
  Datatable: 'Datatable',
  'CHARTS AND MAPS': 'CHARTS AND MAPS',
  Charts: 'Charts',
  'Apex Chart': 'Apex Chart',
  Chartjs: 'Chartjs',
  'Leaflet Maps': 'Leaflet Maps',
  Others: 'Others',
  'Menu Levels': 'Menu Levels',
  'Menu Level 2.1': 'Menu Level 2.1',
  'Menu Level 2.2': 'Menu Level 2.2',
  'Menu Level 3.1': 'Menu Level 3.1',
  'Menu Level 3.2': 'Menu Level 3.2',
  'Disabled Menu': 'Disabled Menu',
  'Raise Support': 'Raise Support',
  Documentation: 'Documentation',
  'Charts & Maps': 'Charts & Maps',
  Apps: 'Apps',
  'User Interface': 'User Interface',
  'Forms & Tables': 'Forms & Tables',
  message: {
    component: {
      missing_recaptcha: 'Please tick "I\'m not a robot"',
      select_all: 'Select All',
      countdown: 'Please input the verification code in {0}',
      location_selector: {
        add: 'Add Location(s)',
        delete: 'Delete Location',
        predefined: 'Predefined Locations:',
      },
      crud_table: {
        leave_dialog: 'The information has not been saved, do you want to leave this page?',
        required: 'Incomplete information!',
      },
    },
    chat: {
      empty: 'No message.',
      typing: 'is typing.',
    },
    date: {
      sunday: 'Sun',
      monday: 'Mon',
      tuesday: 'Tue',
      wednesday: 'Wed',
      thursday: 'Thu',
      friday: 'Fri',
      saturday: 'Sat',
      amomentago: 'a moment ago',
      minutesago: ' minutes ago',
      hoursago: ' hours ago',
      adayago: 'a day ago',
      month: ' Month',
      day: ' Day',
      hour: ' Hour',
      minute: ' Minute',
    },
    zoei: 'Zoei',
    jobtotal: 'JobTotal Limited',
    nav: {
      logout: 'Logout',
      playground: 'playground',
      about: 'About JOBTOTAL',
      search: 'Job Search',
      seeker: 'Seeker',
      employer: 'Employer',
      post: 'Post a Job',
      profile: 'Profile',
      ads: 'Job Ads',
      candidate: 'Candidates',
      talent: 'Talent',
      purchase: 'Purchase',
      billing: 'billing',
      employer_settings: 'Settings',
      seeker_site: 'Seeker Site',
      employer_site: 'Employer Site',
      org_site: 'Organization Site',
      org: 'NGO / ERB Member',
      org_management: 'Post Management',
      org_profile: 'Profile Setting',
      admin_company: 'Company',
      admin_jobfair: 'Jobfair',
      admin_company_user: 'Member',
      admin_company_config: 'Config',
    },
    search: {
      searchbar: 'Job Title, Keyword or Company',
      search_btn: 'Search',
      location: 'Work Location',
      job_type: 'Job Category',
      apply: 'apply',
      favorites: 'favorites',
      prev: 'previous',
      next: 'next',
      employment_types: 'Employment Types',
      shifts: 'Shifts',
    },
    rules: {
      eitherOne: 'Please input email or phone!',
      required: 'required 必填',
      min: 'Min {0} characters',
      email: 'Invalid e-mail.',
      phone: 'Invalid phone.',
      password_mismatch: 'Password mismatch.',
      agree: 'You must agree privacy policy and terms & conditions to complete the register.',
    },
    login: {
      or: 'OR',
      login: 'Login',
      forgot: 'Forget Password?',
      employer_login: 'Employer Login',
      register: 'Register',
      org_login: 'NGO / ERB Member Login',
      admin_login: 'Admin Login',
      email: 'Email Address',
      email_holder: 'Please enter your email address!',
      email_hint: 'It must be a valid email address.',
      password: 'Password',
      password_holder: 'Please enter your password!',
      password_hint: 'At least 6 characters.',
      phone: 'Mobile Number',
      phone_holder: 'Please enter your mobile number!',
      phone_hint: 'It must be a valid mobile number.',
      seeker_login: 'Job Seeker Login',
      forgot_title: 'Get back your Jobtotal account.',
      forgot_subtitle: 'Please enter your account information!',
      forgot_holder: 'Please enter your email or mobile phone!',
      continue: 'Continue',
      forgot_dialog: {
        phone_title: 'Confirm your phone number.',
        email_title: 'Confirm your email.',
        text: 'We will send a 6-digit verification code to:',
        footer: 'Message fees may apply to messages sent by Jobtotal',
        code_holder: 'Please input 6 digits verification code',
      },
    },
    button: {
      send: 'Send',
      confirm: 'Confirm',
      cancel: 'Cancel',
    },
    register: {
      reset: 'Reset Password',
      org_register: 'NGO / ERB Member Register',
      email: 'Email',
      email_holder: 'Please enter your email address!',
      email_hint: 'Please enter a valid email address.',
      first_name: 'First Name',
      first_name_holder: 'Please enter your first name!',
      last_name: 'Last Name',
      last_name_holder: 'Please enter your last name!',
      organization_name: 'Organization Name',
      organization_name_holder: 'Please enter your organization name!',
      phone: 'Mobile Number',
      phone_holder: 'Please enter your mobile number!',
      phone_hint: 'Please enter your mobile number.',
      password: 'Password',
      password_holder: 'Please enter your password in minimum 8 digits!',
      password_hint: 'At least 8 digits.',
      confirm_password: 'Confirm Password',
      confirm_password_holder: 'Please re-enter your password!',
      agree_hint: "By clicking Register, you agree to accept JobTotal Limited's ",
      new_tab: 'Opens in new window',
      privacy: 'privacy policy',
      terms: 'terms & conditions',
      agree_and: ' and ',
    },
    org: {
      register_infor:
        'You have successfully registered, please fill in the profile and edit your posting. We will make a one-stop approval within two working days!',
      management: {
        title: 'Post Management',
        refresh: 'Refresh',
        new: 'New Item',
        edit: 'Edit Item',
        delete: 'Are you sure you want to delete this item?',
        empty: 'No Data',
        save: 'Save',
        update: 'Update',
        confirm: 'Confirm',
        cancel: 'Cancel',
        headers: {
          name_en: 'English Title',
          name_tc: 'Chinese Title',
          category: 'Category',
          start_date: 'Start Date',
          end_date: 'End Date',
          fee: 'Fee',
          actions: 'Actions',
        },
        footer: {
          rows_per_page: 'Rows per page:',
        },
        post: {
          name_en: 'English Title',
          name_tc: 'Chinese Title',
          category_id: 'Category',
          post_date: 'Post Date',
          start_date: 'Start Date',
          end_date: 'End Date',
          start_time: 'Start Time',
          end_time: 'End Time',
          fee: 'Fee',
          url: 'Website(URL)',
          description_en: 'English Introduction',
          description_tc: 'Chinese Introduction',
          locations: 'Locations',
          locations_sub: 'At least enter one location',
          required: 'Please enter all required information!',
        },
      },
      profile: {
        title: 'Profile Settings',
        subtitle: 'Update Information',
        update: 'Update',
        cancel: 'Reset',
        email: 'Email',
        name_en: 'English Name',
        name_tc: 'Chinese Name',
        phone: 'Phone',
        url: 'Web Site (URL)',
        logo: 'Organization Logo',
        description_en: 'English Introduction',
        description_tc: 'Chinese Introduction',
        locations: 'Center Locations*',
        locations_sub: 'At least enter one location',
        district: 'District',
        address_tc: 'Chinese Address',
        address_en: 'English Address',
      },
    },
    toast: {
      updated: 'updated',
      error: 'error occurred: {0}',
      uploaded: 'Successfully Uploaded',
    },
    admin: {
      company: {
        user_limitation: 'User Limitation: ',
        title: 'Company',
        new: 'New Item',
        edit: 'Edit Item',
        delete: 'Are you sure you want to delete this item?',
        empty: 'No Data',
        save: 'Save',
        update: 'Update',
        confirm: 'Confirm',
        cancel: 'Cancel',
        refresh: 'Refresh',
        headers: {
          business_name: 'Company Name',
          contact_name: 'Contact Name',
          contact_phone: 'Contact Phone',
          br_number: 'BR Number',
          verify_user: 'Verify User',
          verify_date: 'Verify Date',
          company_status_id: 'Company Status',
          company_suspension_id: 'Company Suspension Status',
          actions: 'Actions',
        },
        record: {
          display_name: 'Name',
          description: 'Description',
          company_url: 'Website Url',
          // facebook: 'facebook',
          // logo_file_id: 'logo_file_id',
          business_name: 'Name',
          br_number: 'BR Number',
          // br_file_id: 'br_file_id',
          contact_name: 'Contact Person Name',
          contact_email: 'Contact Person Email',
          contact_phone: 'Contact Phone',
          category_id: 'Category',
          company_status_id: 'Company Status',
          company_suspension_id: 'Company Suspension Status',
        },
      },
      jobfair: {
        title: 'Jobfair',
        new: 'New Job Fair',
        edit: 'Edit Job Fair',
        delete: 'Are you sure you want to delete this Job Fair?',
        empty: 'No Data',
        save: 'Save',
        update: 'Update',
        confirm: 'Confirm',
        cancel: 'Cancel',
        refresh: 'Refresh',
        company_headers: {
          name_phone: 'Name',
          post_count: 'Post Count',
          interviewer_count: 'Interviewer Count',
          status_id: 'Status',
          actions: 'Actions',
        },
        company: 'Company',
        add_company: 'Add Company',
        company_status: {
          waiting: 'Waiting',
          approve: 'Approve',
          reject: 'Reject',
          delete: 'Delete',
        },
        headers: {
          event_date: 'Event Date',
          name_en: 'Name (EN)',
          name_tc: 'Name (TC)',
          category_id: 'Category',
          status_id: 'Status',
          quota: 'Quota',
          joined_company: 'Joined Company',
          actions: 'Actions',
        },
        record: {
          name_en: 'Name (EN)',
          name_tc: 'Name (TC)',
          status_id: 'Status',
          category_id: 'Category',
          quota: 'Quota',
          remark: 'Remark',
        },
      },
    },
  },
}
